import moment from 'moment';
import 'moment-duration-format';
import { park30davgQuery, park1dQuery, catchErrorsV2 } from '../ReportsAPI';
import { getSelectedItems } from 'common/state.helper';
import { Logger } from 'common/logger';

const initialState = {
    park: {
        total_number_of_persons_visited: 0,
        completed_work_orders: 0,
        average_generation: 0,
        stopped_turbines_count: 0,
        wave_height_safety_threshold: 0,
        release_of_plant_duration: 0,
        person_vessel_time: 0,
        unavailable_turbine_count: 0,
        person_count_offshore: 0,
        person_deployment_time: 0,
        total_number_of_visits: 0,
        stopped_5d_turbines_count: 0,
        total_count_of_turbines_visited: 0,
        commercial_availability: 0,
        release_of_plant_count_hv: 0,
        release_of_plant_count: 0,
        wind_speed: 0,
        person_time_on_turbine: 0,
        personDeploymentTime: 0,
        release_of_plant_count_multiple: 0,
        person_transfer_count: 0,
        capacity_factor: 0,
        release_of_plant_count_wt: 0,
        issued_work_orders: 0,
        total_generation: 0,
    },
    average: {
        average_generation: 0,
        completed_work_orders: 0,
        stopped_turbines_count: 0,
        release_of_plant_duration: 0,
        average_person_vessel_time: 0,
        unavailable_turbine_count: 0,
        person_count_offshore: 0,
        person_deployment_time: 0,
        average_number_of_persons_visited: 0,
        stopped_5d_turbines_count: 0,
        total_count_of_turbines_visited: 0,
        commercial_availability: 0,
        release_of_plant_count: 0,
        wind_speed: 0,
        person_time_on_turbine: 0,
        personDeploymentTime: 0,
        person_transfer_count: 0,
        capacity_factor: 0,
        average_number_of_visits: 0,
        total_generation: 0,
    },
};

const overviewTotal = {
    name: 'overviewTotal',
    state: initialState,

    reducers: {
        setAverageData(state, payload) {
            Logger.info('Setting average data:', payload);
            return { ...state, average: { ...payload } };
        },
        setParkData(state, payload) {
            Logger.info('Setting park data:', payload);
            return { ...state, park: { ...payload } };
        },
    },

    effects: (dispatch) => ({
        loadAll() {
            Logger.info('Loading all overviewTotal data');
            catchErrorsV2(
                () => dispatch.overviewTotal.queryAverageData({}),
                () => dispatch.overviewTotal.setAverageData({})
            );
            catchErrorsV2(
                () => dispatch.overviewTotal.queryParkData({}),
                () => dispatch.overviewTotal.setParkData({})
            );
        },

        async queryAverageData(_, rootState) {
            const { selectedDate, selectedParkId } = getSelectedItems(rootState);

            Logger.info(`[${selectedParkId}] Querying average data: ${selectedDate}`);
            const { data } = await park30davgQuery(selectedDate, selectedParkId);
            if (data && data.length > 0) {
                const [item] = data;

                const payload = {
                    ...item,
                    person_deployment_time: moment.duration(item.person_deployment_time, 'h').asMilliseconds(),
                    release_of_plant_duration: moment.duration(item.release_of_plant_duration, 'h').asMilliseconds(),
                    person_time_on_turbine: moment.duration(item.person_time_on_turbine, 'h').asMilliseconds(),
                    average_person_vessel_time: moment.duration(item.average_person_vessel_time, 'h').asMilliseconds(),
                };
                dispatch.overviewTotal.setAverageData(payload);
                Logger.info(`[${selectedParkId}] Average data loaded`, item.total_generation);
            } else {
                Logger.info(`[${selectedParkId}] Average data loaded, but empty`);
                dispatch.overviewTotal.setAverageData({});
            }
        },

        async queryParkData(_, rootState) {
            const { selectedDate, selectedParkId } = getSelectedItems(rootState);
            const { data } = await park1dQuery(selectedDate, selectedParkId);

            if (data && data.length > 0) {
                const [item] = data;
                const payload = {
                    ...item,
                    total_generation: item.total_generation || null,
                    person_deployment_time: moment.duration(item.person_deployment_time, 'h').asMilliseconds(),
                    release_of_plant_duration: moment.duration(item.release_of_plant_duration, 'h').asMilliseconds(),
                    person_time_on_turbine: moment.duration(item.person_time_on_turbine, 'h').asMilliseconds(),
                    person_vessel_time: moment.duration(item.person_vessel_time, 'h').asMilliseconds(),
                };
                dispatch.overviewTotal.setParkData(payload);

                Logger.info(`[${selectedParkId}] Park data loaded`, item.total_generation);
            } else {
                Logger.info(`[${selectedParkId}] Park data loaded, but empty`);
                dispatch.overviewTotal.setParkData({});
            }
        },

        async fakeEffectForUnitTest() {
            return new Promise((resolve) => {
                resolve('');
            });
        },
    }),
};

export default overviewTotal;
